<script setup>
import CheckBox from "@/components/ai-onboarding/partials/CheckBox.vue";

const model = defineModel({
  type: [Boolean],
  required: false,
  default: false,
});

</script>

<template>
  <div class="tw-flex tw-w-full  tw-items-center tw-gap-4">
    <label class="tw-flex tw-items-center tw-gap-2">
      <CheckBox
        v-model="model"
      />
      <span>Yes</span>
    </label>

    <label class="tw-flex tw-items-center tw-gap-2">
      <CheckBox
        v-model="model"
        :true-value="false"
      />
      <span>No</span>
    </label>
  </div>
</template>
